import { APIStatus } from '@application/common/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { getAllBrandsAsync } from './BrandThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const brandSlice = createSlice({
    name: 'brand',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllBrandsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllBrandsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.brands = action.payload;
            state.brandsDropdown = action.payload.filter(brand => brand.category === 'Merk').map((brand) => {
                return {
                    label: `${brand.name}`,
                    value: brand.id
                };
            });
            state.brandsBrandLableDropdown = action.payload.filter(brand => brand.category === 'Merk').map((brand) => {
                return {
                    label: `${brand.name}`,
                    value: brand.name
                };
            });
            state.brandsUnitDropdown = action.payload.filter(brand => brand.category === 'Eenheid').map((brand) => {
                return {
                    label: `${brand.name}`,
                    value: brand.name
                };
            });
        })
            .addCase(getAllBrandsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default brandSlice.reducer;
